import React from 'react';
import { Handle } from 'rc-slider';

import './slider-tooltip.scss';

interface SliderTooltipProps {
  index: number;
  value: number;
}

function SliderTooltip(props: SliderTooltipProps) {
  const { index, value, ...rest } = props;

  return (
    <Handle
      key={index}
      styleName="container"
      {...rest}
      dragging={value.toString()}
    >
      <span styleName={value > 10 ? 'tooltip' : 'tooltip-left'}>{value}k</span>
    </Handle>
  );
}

export default SliderTooltip;
